export class DefaultDeviceCategory {
  name: string;
  description: string;
}
